import { useSelector } from 'react-redux';

const useMappingPackage = () => {
  const packages = useSelector((state) => state.packages.packages);

  const handleGetPackageCodeMapping = ({ level, type, expiresIn } = {}) => {
    const pkg = packages.find(
      (p) => p.level === level && p.type === type && p.expiresIn === expiresIn,
    );
    return pkg?.code;
  };

  const getPurchaseEligibilityUpgrade = (packageCode) => {
    const PURCHASE_ELIGIBILITY_UPGRADE_MAP = {
      'STUDIO-VIP-MONTH-V3': 'STUDIO-VIP-MONTH-V3.1',
      'STUDIO-VIP-YEAR-V3': 'STUDIO-VIP-YEAR-V3.1',
    };
    return PURCHASE_ELIGIBILITY_UPGRADE_MAP[packageCode] || packageCode;
  };

  return {
    packages,
    handleGetPackageCodeMapping,
    getPurchaseEligibilityUpgrade,
  };
};

export { useMappingPackage };
